import { Box, ButtonBase } from "@mui/material";

/**
 * Общие атомы для PIN-drawers: индикатор точек и цифровая клавиатура.
 * Стиль тот же, что был в `ChangePinDrawer`, без градиентов — переиспользуется
 * в `ChangePinDrawer` (смена PIN) и `RevealPinDrawer` (показ реквизитов).
 */

export function PinDots({
  length,
  filled,
  error,
}: {
  length: number;
  filled: number;
  error?: boolean;
}) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        gap: "16px",
        marginBottom: "22px",
      }}
    >
      {Array.from({ length }).map((_, i) => (
        <Box
          key={i}
          sx={(theme) => ({
            width: "14px",
            height: "14px",
            borderRadius: "50%",
            border: "1.5px solid",
            borderColor: error
              ? "#FF5A5A"
              : i < filled
              ? "primary.main"
              : theme.palette.mode === "dark"
              ? "rgba(255, 255, 255, 0.25)"
              : "rgba(0, 0, 0, 0.25)",
            bgcolor: error
              ? "#FF5A5A"
              : i < filled
              ? "primary.main"
              : "transparent",
            transition: "all 0.15s",
          })}
        />
      ))}
    </Box>
  );
}

export function Keypad({
  onDigit,
  onBackspace,
  disabled,
}: {
  onDigit: (d: string) => void;
  onBackspace: () => void;
  disabled?: boolean;
}) {
  const keys = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "", "0", "back"];

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: "10px",
      }}
    >
      {keys.map((k, i) => {
        if (k === "") return <Box key={i} />;
        if (k === "back") {
          return (
            <ButtonBase
              key={i}
              disabled={disabled}
              onClick={onBackspace}
              sx={(theme) => ({
                height: "56px",
                borderRadius: "18px",
                fontSize: "18px",
                fontWeight: 500,
                color: "text.secondary",
                bgcolor:
                  theme.palette.mode === "dark"
                    ? "rgba(255, 255, 255, 0.04)"
                    : "rgba(0, 0, 0, 0.04)",
                "&:active": {
                  bgcolor:
                    theme.palette.mode === "dark"
                      ? "rgba(255, 255, 255, 0.1)"
                      : "rgba(0, 0, 0, 0.1)",
                },
                "&.Mui-disabled": { opacity: 0.5 },
              })}
            >
              ⌫
            </ButtonBase>
          );
        }
        return (
          <ButtonBase
            key={i}
            disabled={disabled}
            onClick={() => onDigit(k)}
            sx={(theme) => ({
              height: "56px",
              borderRadius: "18px",
              fontSize: "22px",
              fontWeight: 500,
              color: "text.primary",
              bgcolor:
                theme.palette.mode === "dark"
                  ? "rgba(255, 255, 255, 0.06)"
                  : "rgba(0, 0, 0, 0.06)",
              "&:active": {
                bgcolor:
                  theme.palette.mode === "dark"
                    ? "rgba(255, 255, 255, 0.14)"
                    : "rgba(0, 0, 0, 0.12)",
              },
              "&.Mui-disabled": { opacity: 0.5 },
            })}
          >
            {k}
          </ButtonBase>
        );
      })}
    </Box>
  );
}
